import axios, { AxiosPromise, AxiosResponse } from 'axios';
import { useEffect, useState } from 'react';

import { BaseApiParams } from './baseApi';

const isValidFunc = <R, D>(
  func: (...args: Array<D | BaseApiParams>) => AxiosPromise<R>,
  data: Array<D>
) => func && typeof func === 'function' && func.length === data.length + 1;

function useApi<R, D>(
  func: (...args: Array<D | BaseApiParams>) => AxiosPromise<R>,
  data: Array<D>,
  defaultValue = undefined,
  xhrParams?: BaseApiParams
) {
  // todo use generic instead of any
  const [state, setState] = useState<{
    fetched?: R;
    pending: boolean;
    response?: Partial<AxiosResponse>;
  }>({
    response: defaultValue ? { data: defaultValue } : undefined,
    pending: isValidFunc(func, data) ? true : false,
  });
  const { fetched, response, pending } = state;

  useEffect(() => {
    let cancelled = false;
    const source = axios.CancelToken.source();

    if (isValidFunc(func, data)) {
      // console.log(func, data, 'call');
      setState({ pending: true });
      const promise = data
        ? func(...data, { cancelToken: source.token, ...xhrParams })
        : func({ cancelToken: source.token, ...xhrParams });

      promise.then((promiseResponse) => {
        if (!cancelled) {
          if (promiseResponse) {
            // success
            setState({
              pending: false,
              fetched:
                promiseResponse?.status === 200
                  ? promiseResponse.data
                  : undefined,
              response: promiseResponse,
            });
          } else {
            // error
            setState({ pending: false });
          }
        }
      });
    }

    return () => {
      cancelled = true;
      source.cancel('');
    };
  }, [func, data, xhrParams]);

  return { fetched, pending, response };
}

export { useApi };
